import { SVGProps } from "react"
const X3Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.6763 1.8868C14.1079 1.45517 14.1079 0.755361 13.6763 0.323727C13.2446 -0.107907 12.5448 -0.107909 12.1132 0.323721L6.99994 5.43693L1.8868 0.323833C1.45517 -0.107797 0.755352 -0.107794 0.323721 0.32384C-0.107909 0.755474 -0.107907 1.45529 0.323728 1.88692L5.43686 7L0.323728 12.1131C-0.107907 12.5447 -0.107909 13.2445 0.323721 13.6762C0.755352 14.1078 1.45517 14.1078 1.8868 13.6762L6.99994 8.56307L12.1132 13.6763C12.5448 14.1079 13.2446 14.1079 13.6763 13.6763C14.1079 13.2446 14.1079 12.5448 13.6763 12.1132L8.56303 7L13.6763 1.8868Z"
      fill="#0E2846"
    />
  </svg>
)
export default X3Icon
